import { useEffect, useState } from 'react';

/**
 * Abstand der rechten Kante eines Elements zum rechten Fensterrand in px.
 *
 * Für fest positionierte Bedienelemente, die optisch zu einem Bereich gehören statt zum
 * Fenster (das ＋-Dock sitzt am rechten Rand der Playmat): wird der Bereich schmaler, etwa
 * weil sich daneben die Katalog-Spalte öffnet, rückt das Element mit. Misst per
 * ResizeObserver und beim Fenster-Resize; ohne ResizeObserver (jsdom) bleibt der Wert 0.
 */
export default function useRightInset(ref) {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;
    const measure = () => {
      const rect = el.getBoundingClientRect();
      setInset(Math.max(0, Math.round(window.innerWidth - rect.right)));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    window.addEventListener('resize', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [ref]);

  return inset;
}
